import React, { useCallback } from "react";
import { useFilterStore } from "./FilterStoreProvider";
import { GENDER_OPTIONS } from "../../../models/product";
import { isFilterEmpty } from "./FilterStore";

import Accordion from "./components/Accordion";
import GenderFilter from "./components/GenderFilter";
import CategoryFilter from "./components/CategoryFilter";
import BrandFilter from "./components/BrandFilter";
import PriceFilter from "./components/PriceFilter";
import StatusFilter from "./components/StatusFilter";

import "./FilterPanel.css";

/**
 * PC용 필터 패널 컴포넌트
 * 필터 변경 시 즉시 스토어의 상태를 업데이트합니다.
 */
function FilterPanel() {
  // --- Zustand Store and State --- //
  const { filters, handleFilterChange, resetAllFilters } = useFilterStore(
    (state) => ({
      filters: state.filters,
      handleFilterChange: state.handleFilterChange,
      resetAllFilters: state.resetAllFilters,
    }),
  );

  // --- Event Handlers --- //
  // 필터 객체의 일부를 업데이트하는 범용 핸들러
  const updateFilters = useCallback(
    (newValues) => {
      // 기존 필터 상태와 새로운 값을 병합하여 스토어에 전달
      handleFilterChange({ ...filters, ...newValues });
    },
    [filters, handleFilterChange],
  );

  const showReset = !isFilterEmpty(filters);

  return (
    <aside className="FilterPanel" onClick={(e) => e.stopPropagation()}>
      <div className="FilterPanel-header">
        <h3 className="FilterPanel-title">필터</h3>
        {showReset && (
          <button
            type="button"
            className="FilterPanel-reset-button"
            onClick={resetAllFilters}
          >
            초기화
          </button>
        )}
      </div>

      <div className="FilterPanel-content">
        <StatusFilter
          isSelling={filters.isSelling}
          condition={filters.condition}
          onChange={updateFilters} // {isSelling, condition} 객체를 그대로 전달
        />

        <Accordion title="성별" initialOpen>
          <GenderFilter
            gender={filters.gender || ""}
            options={GENDER_OPTIONS}
            onChange={(gender) => updateFilters({ gender })} // 단일 값은 객체로 감싸서 전달
          />
        </Accordion>

        <Accordion title="카테고리">
          <CategoryFilter
            gender={filters.gender || ""}
            categoriesFilter={filters.categories || []}
            subcategoryIds={filters.subcategoryIds || []}
            onChange={updateFilters} // {categories, subcategoryIds} 객체를 그대로 전달
          />
        </Accordion>

        <Accordion title="브랜드">
          <BrandFilter
            selectedBrands={filters.brands || []}
            onChange={(brands) => updateFilters({ brands })}
          />
        </Accordion>

        <Accordion title="가격">
          <PriceFilter
            priceMin={filters.priceMin}
            priceMax={filters.priceMax}
            onApply={(priceMin, priceMax) =>
              updateFilters({ priceMin, priceMax })
            }
          />
        </Accordion>
      </div>
    </aside>
  );
}

export default FilterPanel;
